import { render, staticRenderFns } from "./DepartModal.vue?vue&type=template&id=31cfd3c4&scoped=true&"
import script from "./DepartModal.vue?vue&type=script&lang=js&"
export * from "./DepartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cfd3c4",
  null
  
)

export default component.exports